<app-content-wrapper>
  @if (checkingForUserdataset()) {
    <div class="datasetCheckingBlocker"></div>
  }
  <app-topbar>
    <div app-topbar-title>
      <i class="far fa-table"></i>
      <span>Visual - {{isAddMode() ? "Add" : "Edit" }}</span>
    </div>

    <div class="topbar-buttons">
      <button trgButton color="blue-outline" class="text-left" (click)="goBackClick()" [disabled]="disableTopbar()">
        <i class="far fa-chevron-left i-12 mr-8"></i>
        <span>Back</span>
      </button>

      <button trgButton color="primary" class="ml-16 text-left" (click)="saveClick()" [disabled]="disableTopbar()">
        <i class="fas fa-save i-12 mr-8"></i>
        <span>Save</span>
      </button>

      <button trgButton color="primary" class="ml-16 text-left" (click)="saveAndCloseClick()" [disabled]="disableTopbar()">
        <i class="fas fa-save i-12 mr-8"></i>
        <span>Save &amp; Close</span>
      </button>
    </div>
  </app-topbar>

  <div class="content-container background-box bgc-grey-4 visual-editor__content-container">
    <div [hidden]="!displaySpinner()" class="visual-editor__spinner">
      <app-spinner></app-spinner>
    </div>

    <trg-editor-container [hidden]="displaySpinner()" [class.cursor-wait]="busy()" [contentClass]="'overflow-hidden'">
      <visual-editor-topbar trg-editor-toolbar
                            [busy]="busy()"
                            [autoRefresh]="autoRefresh()"
                            (autoRefreshChange)="setAutoRefresh($event)"
                            [showUserDatasetState]="showUserDatasetState()"
                            [userDatasetState]="userDatasetState()">
      </visual-editor-topbar>

      <div class="editor">
        <div class="editor-dialog-backdrop"
             [hidden]="!showEditorDialogBackdrop()"></div>

        <visual-editor-layout-section [busy]="busy()"
                                      [dataset]="dataset()"
                                      (datasetChange)="trySetDataset($event)"
                                      [(hideUnmatchedFields)]="hideUnmatchedFields"
                                      [visualType]="visualType()"
                                      [visual]="visual()">
        </visual-editor-layout-section>

        <visual-editor-canvas-section [busy]="busy()"
                                      [visualId]="visualId()"
                                      [visual]="displayedVisual()"
                                      [visualDataSource]="visualDataSource"
                                      [refreshPending]="refreshPending()"
                                      (refreshVisual)="refreshVisual()">
        </visual-editor-canvas-section>
      </div>
    </trg-editor-container>
  </div>
</app-content-wrapper>

<app-expr-editor #exprEditor
                 [disabled]="busy()"
                 [readonly]="busy()"
                 [displayMode]="ExprEditorDisplayMode"
                 [allowEmpty]="false"
                 [checkForCyclicDeps]="null"
                 [fields]="exprEditorFieldGroups()"
                 [fieldResolver]="customFieldResolver"
                 [functions]="exprEditorFunctionGroups()"
                 [hideUnmatchedFields]="hideUnmatchedFields()"
                 [nameEditing]="exprEditorNameEditing()"
                 [value]="exprEditorValue()"
                 (valueChange)="onExprEditorValueChange($event)"
                 [name]="exprEditorName()"
                 (nameChange)="onExprEditorNameChange($event)"
                 [usedNames]="usedCustomFieldNames()"></app-expr-editor>
